import { Component, OnInit, ViewChild } from '@angular/core';
import { MapInfoWindow, MapMarker } from '@angular/google-maps';
import { Title, Meta } from '@angular/platform-browser';
import { HttpService } from '../http.service';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Contact } from '../contact';


@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss']
})
export class ContactComponent implements OnInit {

  title = 'Contact';
  // google maps zoom level
  zoom: number = 14;

  center: google.maps.LatLngLiteral = { lat: 49.28009, lng: -123.117844 };
  circleOptions: google.maps.CircleOptions = {
    radius: 5000,
    fillColor: 'red',
    draggable: true,
    editable: true
  };
  mapOptions: google.maps.MapOptions;
  contactForm: FormGroup;
  emaiSend: boolean = false;
  contactValue: Contact;
  ipAddress: string;
  createDate: DateConstructor;

  @ViewChild(MapInfoWindow) infoWindow: MapInfoWindow;
  selectedMarkerLabel?: string;

  constructor(public router: Router,
    private titleService: Title, 
    private metaService: Meta,
    private _http: HttpService,
    private fb: FormBuilder,) { }

  ngOnInit(): void {
    this.titleService.setTitle(this.title);
    this.metaService.addTags([
      {name: 'robots', content: 'index, follow'}
    ]);
    this.metaService.updateTag({name: 'keywords', content: 'Contact'});
    this.metaService.updateTag({name: 'description', content: 'Contact'});

    this.contactForm = this.fb.group({
      yourName: ['', Validators.required],
      email: ['', [Validators.required, Validators.maxLength(30), Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$")]],
      message: ['', [Validators.required, Validators.maxLength(255)]]
    });

    this.mapOptions = {
      disableDefaultUI: false,
      zoomControl: false,
      streetViewControl: false,
      styles: this.styles
    };

    this.getIP();
  }

  getIP()  
  {  
    this._http.getIPAddress().subscribe((res:any)=>{  
      this.ipAddress=res.ip;  
    });  
  }

  onSubmit() {
    this.contactValue = this.contactForm.value;
    this.contactValue.ip = this.ipAddress;
    this.contactValue.createTime = new Date().toDateString();
    this.contactValue.post_type = 'contacts';
    // console.log(this.contactValue);
    this._http.sentForm(this.contactValue)
      .subscribe(data => {
        this.router.navigate(['contact']);
        this.emaiSend = true;
      })
  }

  clickedMarker(label: string | undefined, index: number, marker: MapMarker) {
    this.selectedMarkerLabel = label || index.toString();
    if (this.infoWindow) {
      this.infoWindow.open(marker);
    }
  }

  mapClicked(event: google.maps.MapMouseEvent) {
    if (event.latLng) {
      const position = event.latLng.toJSON();
      this.markers.push({
        position,
        label: `Marker ${this.markers.length + 1}`,
        draggable: false
      });
    }
  }

  markerDragEnd(marker: MapMarkerData, event: google.maps.MapMouseEvent) {
    console.log('dragEnd', marker, event);
  }

  markers: MapMarkerData[] = [
	  {
		  position: { lat: 49.28009, lng: -123.117844 },
		  label: 'Hi',
		  draggable: false
	  }
  ];

  styles: any[] =
    [
      {
        "featureType":"landscape.natural",
        "elementType":"geometry.fill",
        "stylers":[
            {
              "color":"#dfdfdf"
            }
        ]
      },
      {
        "featureType":"landscape.man_made",
        "elementType":"geometry.fill",
        "stylers":[
            {
              "color":"#d7d9d9"
            }
        ]
      },
      {
        "featureType":"road.highway",
        "elementType":"geometry.fill",
        "stylers":[
            {
              "color":"#afafaf"
            }
        ]
      },
      {
        "featureType":"road.arterial",
        "elementType":"geometry.fill",
        "stylers":[
            {
              "color":"#dedede"
            }
        ]
      },
      {
        "featureType":"road",
        "elementType":"geometry.fill",
        "stylers":[
            {
              "color":"#ababab"
            }
        ]
      },
      {
        "featureType":"poi",
        "elementType":"geometry.fill",
        "stylers":[
            {
              "color":"#e6e6e6"
            }
        ]
      },
      {
        "featureType":"road.local",
        "elementType":"labels.text.fill",
        "stylers":[
            {
              "color":"#010404"
            }
        ]
      },
      {
        "featureType":"road.arterial",
        "elementType":"labels.text.fill",
        "stylers":[
            {
              "color":"#040404"
            }
        ]
      },
      {
        "featureType":"road.highway",
        "elementType":"labels.text.fill",
        "stylers":[
            {
              "color":"#0f0f01"
            }
        ]
      }
  ]

}

// just an interface for type safety.
interface MapMarkerData {
	position: google.maps.LatLngLiteral;
	label?: string;
	draggable: boolean;
}
